"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeading = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("analytics-and-reports-settings");
var SectionHeading = function (_a) {
    var id = _a.id, icon = _a.icon, headingText = _a.headingText, description = _a.description;
    return (react_1.default.createElement("div", { className: c("section-heading"), id: id },
        icon && react_1.default.createElement("div", { className: c("section-heading-icon") }, icon),
        react_1.default.createElement(kaleidoscope_1.Label, { element: "div" }, headingText),
        description && react_1.default.createElement("div", { className: c("section-heading-description") }, description)));
};
exports.SectionHeading = SectionHeading;
